import React from 'react'
import TotalsoldVector from "../../Images/TotalsoldVector.png";
import AuctionedVector from "../../Images/auctionedVector.png";
import TransactionVector from "../../Images/TransactionVector.png";
import RoyalityVector from "../../Images/RoyalityVector.png";


import {
    Container,
    Image,
    ImageWrapper,
    NftQuantity,
    NftsWrapper,
    NftsWrapperContainer,
    NftText,
    NftTextWrapper,
    Root,
    Text,
    TextWrapper,
  
  } from "./DashboardCoinholdingstyled";

const DashboardTopSection = ({ sold, otherData}) => {
  return (
    <Root>
    <Container>
      <TextWrapper>
        <Text>Dashboard</Text>
      </TextWrapper>

      <NftsWrapperContainer>
        <NftsWrapper>
          <ImageWrapper>
            <Image src={TotalsoldVector}/>
          </ImageWrapper>
          <NftTextWrapper>
            <NftText>Total Sold</NftText>
            <NftQuantity>{sold}</NftQuantity>
          </NftTextWrapper>
        </NftsWrapper>

        <NftsWrapper>
          <ImageWrapper>
            <Image src={AuctionedVector}/>
          </ImageWrapper>
          <NftTextWrapper>
            <NftText> Platform Fees Earned </NftText>
            {
              otherData?.length > 0 && otherData.map((data) => {
                return (
                  <NftQuantity> {data.platformFeesEarned} {data.name} </NftQuantity>
                )
              })
            }
          </NftTextWrapper>
        </NftsWrapper>

        <NftsWrapper>
          <ImageWrapper>
            <Image src={TransactionVector}/>
          </ImageWrapper>
          <NftTextWrapper>
          <NftText>Transaction</NftText>
            <NftText >Fees received</NftText>
            {
              otherData?.length > 0 && otherData.map((data) => {
                return (
                  <NftQuantity> {data.transaction} {data.name}</NftQuantity>
                )
              })
            }
            {/* <NftQuantity>$4000</NftQuantity> */}
          </NftTextWrapper>
        </NftsWrapper>

        <NftsWrapper>
          <ImageWrapper>
            <Image src={RoyalityVector}/>
          </ImageWrapper>
          <NftTextWrapper>
            <NftText> Royality </NftText>
            {
              otherData?.length > 0 && otherData.map((data) => {
                return (
                  <NftQuantity> {data.royaltyEarned} {data.name} </NftQuantity>
                )
              })
            }
            {/* <NftQuantity> 1500 </NftQuantity> */}
          </NftTextWrapper>
        </NftsWrapper> 

      </NftsWrapperContainer>
    </Container>
  </Root>
  )
}

export default DashboardTopSection